/**
 * Builds the same conversation URL the Microsoft 365 Agents SDK uses for a
 * published Copilot Studio agent (Power Platform API, prod cloud).
 */

const API_VERSION = "2022-03-01-preview"

function stripDashes(value: string) {
  return value.toLowerCase().split("-").join("")
}

export function copilotStudioHost(environmentId: string): string {
  const normalized = stripDashes(environmentId)
  const suffixLength = 2
  const prefix = normalized.slice(0, normalized.length - suffixLength)
  const suffix = normalized.slice(normalized.length - suffixLength)
  return `https://${prefix}.${suffix}.environment.api.powerplatform.com`
}

export function copilotStudioConversationUrl(options: {
  environmentId: string
  schemaName: string
  directConnectUrl?: string
  conversationId?: string
}): string {
  const direct = options.directConnectUrl?.trim()
  const base = direct
    ? new URL(direct)
    : new URL(
        `/copilotstudio/dataverse-backed/authenticated/bots/${encodeURIComponent(
          options.schemaName
        )}`,
        copilotStudioHost(options.environmentId)
      )

  if (!base.searchParams.has("api-version")) {
    base.searchParams.append("api-version", API_VERSION)
  }

  const { pathname: initialPath } = base
  let pathname = initialPath
  if (pathname.endsWith("/")) pathname = pathname.slice(0, -1)
  const conversationsAt = pathname.indexOf("/conversations")
  if (conversationsAt >= 0) pathname = pathname.slice(0, conversationsAt)
  pathname = `${pathname}/conversations`
  if (options.conversationId) {
    pathname = `${pathname}/${encodeURIComponent(options.conversationId)}`
  }
  base.pathname = pathname
  return base.href
}
